import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const subject_types = {
  namespaced: true,
  state: {
    all: {},
    queryParam: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("globals/param/" + payload).then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
  },
};

export default subject_types;
